<template>
  <div id="modal_likedList" class="uk-modal" uk-modal="">
    <div class="uk-modal-dialog liked-modal-dialog">
      <button class="uk-modal-close-default" type="button" uk-close></button>

      <div class="uk-modal-header liked-modal-header">
        <h2 class="uk-modal-title liked-modal-title">
          <i class="uil-heart liked-title-icon"></i>
          <span class="liked-title-text">{{ $t("general.liked_people") }}</span>
          <span v-if="likedList.length" class="liked-count-badge">{{ likedList.length }}</span>
        </h2>
      </div>

      <div class="uk-modal-body liked-modal-body">
        <div v-if="likedList.length" class="liked-list">
          <div
            v-for="user in likedList"
            :key="user.id"
            class="liked-user-item"
          >
            <div class="liked-user-avatar">
              <UserProfileAvatar
                :name="user.fullname || [user.name, user.surname].filter(Boolean).join(' ')"
                :photo="user.photo_link"
                class="liked-user-avatar-image"
              />
            </div>
            <div class="liked-user-info">
              <div class="liked-user-name">{{ user.fullname || `${user.name} ${user.surname}` }}</div>
            </div>
          </div>
        </div>

        <div v-else class="liked-empty-state">
          <i class="uil-heart-break"></i>
          <p>{{ $t("general.no_likes_yet") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfileAvatar from "@/view/components/common/UserProfileAvatar.vue";

export default {
  name: "LikedListModal",
  components: {
    UserProfileAvatar,
  },
  props: {
    likedList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getUserRole(user) {
      if (!user.roles || !user.roles.length) return "";

      const roleNames = {
        super_admin: this.$t("general.super_admin") || "Süper Admin",
        admin: this.$t("general.admin") || "Admin",
        company_admin: this.$t("general.company_admin") || "Şirket Yöneticisi",
        user: this.$t("general.user") || "Kullanıcı",
      };

      const primaryRole = user.roles.find(r =>
        ["super_admin", "admin", "company_admin"].includes(r.name)
      ) || user.roles[0];

      return roleNames[primaryRole.name] || primaryRole.name;
    },
  },
};
</script>

<style scoped>
.liked-modal-dialog {
  max-width: 500px;
  border-radius: 16px;
  overflow: hidden;
}

.liked-modal-header {
  background: linear-gradient(135deg, #0a66c2 0%, #004182 100%);
  padding: 20px 64px 20px 24px;
  border-bottom: none;
}

.liked-modal-title {
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.liked-title-icon {
  flex-shrink: 0;
  font-size: 24px;
  color: #ffffff;
}

.liked-title-text {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.liked-count-badge {
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  margin-left: auto;
}

.liked-modal-dialog > .uk-modal-close-default {
  z-index: 1;
}

.liked-modal-body {
  padding: 0;
  max-height: 400px;
  overflow-y: auto;
}

.liked-list {
  padding: 8px 0;
}

.liked-user-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 24px;
  transition: background 0.2s ease;
  cursor: pointer;
}

.liked-user-item:hover {
  background: #f8fafb;
}

.liked-user-avatar {
  flex-shrink: 0;
}

.liked-user-avatar-image {
  width: 44px;
  height: 44px;
  min-width: 44px;
  font-size: 14px;
}

.liked-user-info {
  flex: 1;
  min-width: 0;
}

.liked-user-name {
  font-size: 15px;
  font-weight: 600;
  color: #191919;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.liked-user-role {
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.liked-empty-state {
  text-align: center;
  padding: 60px 24px;
  color: #9ca3af;
}

.liked-empty-state i {
  font-size: 64px;
  color: #d1d5db;
  margin-bottom: 16px;
  display: block;
}

.liked-empty-state p {
  font-size: 15px;
  color: #6b7280;
  margin: 0;
}

.liked-modal-body::-webkit-scrollbar {
  width: 6px;
}

.liked-modal-body::-webkit-scrollbar-track {
  background: #f3f4f6;
}

.liked-modal-body::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.liked-modal-body::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

@media (max-width: 640px) {
  .liked-modal-header {
    padding: 16px 56px 16px 16px;
  }

  .liked-modal-title {
    min-width: 0;
    gap: 8px;
    font-size: 18px;
  }

  .liked-count-badge {
    padding: 4px 10px;
  }

  .uk-modal-close-default {
    top: 12px;
    right: 12px;
  }
}
</style>
